import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import DialogContentText from "@material-ui/core/DialogContentText";
import {Typography} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import StartRideForm from "./StartRideForm";

const StartRideDialog = ({onCancel, onSubmit}) => {
  const [t] = useTranslation();


  return (
    <Dialog open={true}>
      <DialogTitle>{t('unlockBike.startDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1" style={{textAlign: "justify"}}>
            <StartRideForm onCancel={onCancel} onSubmit={(r) => {
              onSubmit(r)
            }}/>
          </Typography>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}

StartRideDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
export default StartRideDialog;
